import { useQuery } from '@tanstack/react-query';

import { DataLakeTables } from '@graylog/enterprise-api';

import useFeature from 'hooks/useFeature';
import type { DataLakeTableOptions } from 'data-lake/preview/Types';

const fetchDataLakeTablesList = (dataLakeId: string): Promise<DataLakeTableOptions> =>
  DataLakeTables.listTables(dataLakeId).then((dataLakeTables) =>
    dataLakeTables.map((tableInfo) => ({
      label: tableInfo.name,
      value: tableInfo.id,
    })),
  );

const useDataLakeTableOptions = (
  dataLakeId: string,
): {
  data: DataLakeTableOptions;
  isInitialLoading: boolean;
} => {
  const featureIsEnabled = useFeature('external_data_lake_search');

  const { data = [], isInitialLoading } = useQuery<DataLakeTableOptions>({
    queryKey: ['data-lake', 'external-tables', dataLakeId],
    queryFn: () => fetchDataLakeTablesList(dataLakeId),
    enabled: featureIsEnabled && !!dataLakeId,
  });

  return {
    data,
    isInitialLoading: isInitialLoading,
  };
};

export default useDataLakeTableOptions;
